module.exports = __webpack_public_path__ + "static/media/yamaha_logo.57ce6246.svg";